import * as types from "./types";

export const checkFilter = isValid => {
  return {
    type: types.CHECK_FILTER,
    isValid
  };
};

export const getNextStep = payload => {
  return {
    type: types.FILTER_GET_NEXT_STEP,
    payload
  };
};

export const getNextStepVacxin = payload => {
  return {
    type: types.FILTER_GET_NEXT_STEP_VACXIN,
    payload
  };
};

export const setGuaranteeCompanys = payload => {
  return {
    type: types.SET_GUARANTEE_COMPANY,
    payload
  };
};

export const saveGuaranteeCompany = payload => {
  return {
    type: types.FILTER_SAVE_GUARANTEE_COMPANY,
    payload
  };
};

export const getFilterByStep = payload => {
  return {
    type: types.GET_FILTER_BY_STEP,
    payload
  };
};

export const resetFilterByStep = () => {
  return {
    type: types.RESET_FILTER_BY_STEP
  };
};

export const setFilterByStep = payload => {
  return {
    type: types.SET_FILTER_BY_STEP,
    payload
  };
};
